<template>
  <div>
    <a
      v-for="folder in folders"
      :key="folder.id"
      class="list-item is-actionable"
      href="#"
      data-app-target="none"
      @click.prevent="selectFolder(folder)"
    >
      <base-icon name="folder" />
      <div class="list-item-text">
        <div class="big-body-type">{{ folder.name }}</div>
        <div v-if="folder.message" class="small-caption-type">{{ folder.message }}</div>
      </div>
    </a>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseIcon from 'vuecomponents/base_icon'

export default {
  components: { BaseIcon },
  props: {
    folders: {
      default: () => [],
    },
  },
  methods: {
    selectFolder(folder) {
      if (!folder.disabled) {
        this.$emit('select', folder)
      } else {
        // Do nothing
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
i {
  @include directional-margin($margin-left: 0, $margin-right: 16px);
}
</style>
